<template>
  <div>
    <template v-if="party.ageGroup == 0">
      Esse evento é <b>livre</b> para todos os públicos.
    </template>
    <template v-else>
      <p class="mb-0">
        Este evento é para maiores de
        <b class="font-weight-bold">{{ party.ageGroup }} anos</b>.
      </p>

      <template v-if="party.ageWithParent >= 0">
        Jovens
        <template v-if="party.ageWithParent > 0">
          {{ ageDiference > 2 ? "entre" : "de" }}
          <b
            >{{ party.ageWithParent }}
            <template v-if="ageDiference >= 2">
              {{ ageDiference == 2 ? "ou" : "e" }}
              {{ party.ageGroup - 1 }}
            </template>
            anos</b
          >
        </template>
        <template v-else>
          <b class="font-weight-bold">até {{ party.ageGroup - 1 }} anos</b>
        </template>
        podem entrar acompanhados pelos pais ou responsáveis
        <template v-if="party.authorizationTemplate">
          ou com uma carta de autorização assinada pelos mesmos.
        </template>
      </template>
    </template>
    <template v-if="party.ageFree > 0">
      <p class="mb-0">
        Crianças de até
        <b class="font-weight-bold">{{ party.ageFree }} anos</b> não pagam
        ingresso.
      </p>
    </template>
    <a
      v-if="party.authorizationTemplate && !hideDownload"
      @click="downloadPdf"
      class="primary--text text-12 d-block"
    >
      Baixar modelo de autorização para menores
    </a>
  </div>
</template>

<script>
export default {
  computed: {
    ageDiference() {
      const age = this.party.ageGroup;
      const ageWithParent = this.party.ageWithParent;
      return age - ageWithParent;
    },
  },
  methods: {
    downloadPdf() {
      const link = document.createElement("a");
      link.href = this.party.authorizationTemplate;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
  props: {
    party: {
      type: Object,
      required: true,
    },
    hideDownload: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style></style>
